/**
 * A draw the organiser hid (`draw.hidden_from_public`) takes its matches off the public
 * schedule and matches reads (web and app). The flag rides along on each schedule row's
 * `draw_match → draw` embed, so no second query; manual rows with no draw stay.
 * The bracket itself is gated by `isDrawPubliclyVisible` (src/lib/appDrawProjection.ts).
 */
type DrawRef = { draw?: { hidden_from_public?: boolean | null } | null } | null | undefined;

/**
 * Pure: is this one `draw_match` embed on a hidden draw? No draw (a manual row) is not hidden.
 * The schedule's `draw_match` embed is one object or, on some selects, an array.
 */
export function isDrawMatchHidden(drawMatch: DrawRef | DrawRef[]): boolean {
  const dm = Array.isArray(drawMatch) ? drawMatch[0] : drawMatch;
  return dm?.draw?.hidden_from_public === true;
}

/** Pure: drops the rows whose draw is hidden; rows without a draw are kept. */
export function dropHiddenDrawRows<T extends { draw_match?: DrawRef | DrawRef[] }>(rows: T[]): T[] {
  return rows.filter((row) => !isDrawMatchHidden(row.draw_match));
}
